import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { api } from '@/context/AuthContext';
import { usePublicCopy } from '@/i18n/publicCopy';
import { Section } from './HomeSections';

const card = { backgroundColor: 'var(--bg-surface)', border: '1px solid var(--border)' };

/** Home-page teaser: the three newest Soro posts. Renders nothing while the blog has no published posts. */
export function BlogTeaser() {
  const { c } = usePublicCopy();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get('/public/blog/latest?limit=3').then((r) => setPosts(r.data.posts || [])).catch(() => setPosts([])); }, []);
  if (!posts.length) return null;
  const b = c.blog;
  return (
    <Section id="blog" label={b.teaser_title} className="border-t" >
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: 'var(--accent)' }}>{b.teaser_kicker}</p>
          <h2 className="font-heading text-3xl sm:text-4xl font-light tracking-tight" style={{ color: 'var(--text-primary)' }}>{b.teaser_title}</h2>
        </div>
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm hover:underline" style={{ color: 'var(--accent)' }} data-testid="blog-teaser-all">{b.teaser_all} <ArrowRight className="w-4 h-4" aria-hidden="true" /></Link>
      </div>
      <div className="grid md:grid-cols-3 gap-5" data-testid="blog-teaser">
        {posts.map((p) => (
          <Link key={p.slug} to={p.url} className="rounded-2xl overflow-hidden flex flex-col transition-transform hover:-translate-y-0.5" style={card} data-testid={`blog-teaser-post-${p.slug}`}>
            {p.image && <img src={p.image} alt="" className="w-full h-40 object-cover" loading="lazy" />}
            <div className="p-5 flex-1 flex flex-col gap-2">
              {p.date && <time dateTime={p.iso_date} className="text-xs" style={{ color: 'var(--text-secondary)' }}>{p.date}</time>}
              <h3 className="font-heading text-lg leading-snug" style={{ color: 'var(--text-primary)' }}>{p.title}</h3>
              {p.excerpt && <p className="text-sm leading-relaxed line-clamp-3" style={{ color: 'var(--text-secondary)' }}>{p.excerpt}</p>}
              <span className="mt-auto inline-flex items-center gap-1 text-sm" style={{ color: 'var(--accent)' }}>{b.read} <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" /></span>
            </div>
          </Link>
        ))}
      </div>
    </Section>
  );
}
